import { IArticle } from "../models/IArticle";
import { makeAutoObservable } from "mobx";
import ArticlesService from "../service/ArticlesService";
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from "../components/toasts";

interface IarticlesFilters {
  status: string[];
  tags: string[];
}

interface IFilter {
  label: string;
  default: boolean;
  value: string;
}
export default class Articles {
  articlesList: IArticle[] = [];
  loadingArticlesBool: boolean = false;
  articlesFilters: IarticlesFilters = {} as IarticlesFilters;
  articleFilterList: IFilter[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setArticlesList(eventList: IArticle[]) {
    this.articlesList = eventList;
  }

  setArticlesFilters(status: string[]) {
    this.articlesFilters.status = status;
  }

  async loadList(page: number = 1) {
    this.loadingArticlesBool = true;
    const ArticlesList = await ArticlesService.fetchList(
      this.articlesFilters.status,
      page
    );
    this.setArticlesList(ArticlesList.data.result);
    // this.generateFilters(ArticlesList.data.result);
    this.loadingArticlesBool = false;
    return ArticlesList.data;
  }

  async loadFilters(page: number) {
    this.loadingArticlesBool = true;
    const ArticlesList = await ArticlesService.fetchList(
      this.articlesFilters.status,
      page
    );
    this.generateFilters(ArticlesList.data.result);
    this.loadingArticlesBool = false;
  }

  generateFilters = (articles: IArticle[]) => {
    if (articles.length > 0) {
      const categories = articles.map(
        (article) => article.tags?.[0]
      ) as string[];

      const uniqueCategories = Array.from(new Set(categories));
      this.articleFilterList = uniqueCategories.map((category) => ({
        label: category,
        default: false,
        value: category.toLowerCase(),
      }));
    }
  };

  async createOne(data: IArticle, page: number = 1) {
    this.loadingArticlesBool = true;
    showLoadingToast("Creating article...");
    if (typeof data !== "undefined") {
      try {
        await ArticlesService.fetchCreateOne(data);
      } catch (error) {
        console.error(error);
        return showErrorToast("Error creating article");
      }
      await this.loadList(page);
      showSuccessToast("Article created");
    } else {
      console.error("no data to send");
      showErrorToast("Error creating article");
    }
    this.loadingArticlesBool = false;
  }

  async updateOne(data: IArticle | undefined, page: number = 1) {
    this.loadingArticlesBool = true;
    showLoadingToast("Updating article...");
    if (typeof data !== "undefined") {
      await ArticlesService.fetchUpdateOne(data);
      await this.loadList(page);
      showSuccessToast("Article updated");
    } else {
      showErrorToast("Error updating article");
    }
    this.loadingArticlesBool = false;
  }

  async deleteOne(data: IArticle | undefined, page: number = 1) {
    this.loadingArticlesBool = true;
    if (typeof data !== "undefined") {
      await ArticlesService.fetchDeleteOne(data._id);
      await this.loadList(page);
    } else {
      console.error("no data to delete");
      showErrorToast("Error deleting article");
    }
    this.loadingArticlesBool = false;
  }

  async uploadImage(file: File) {
    // showLoadingToast("Uploading image...");
    if (file) {
      try {
        const image = await ArticlesService.uploadImage(file);
        // showSuccessToast("Image uploaded");
        return image.data.url;
      } catch (error) {
        console.error(error);
        // showErrorToast("Error uploading image");
      }
    } else {
      console.error("no file to upload");
      // showErrorToast("Error uploading image");
    }
  }
}
